module.exports = __webpack_public_path__ + "media/images/samples/home/main-b5734ab1a3372ed6aca76361138f9125.png";